import api from "../..";
import { uploadFile } from "../../file/uploadFile";
import type { ApiResponse } from "../../types";
import type {
  UpdateContentBannerParams,
  UpdateTopBannerParams,
} from "./types";
import {
  TOP_ENDPOINT,
  CONTENT_ENDPOINTS,
  CONTENT_FK_FIELD,
  UPLOAD_ITEM_TYPE,
} from "./types";

const upload = async (file: File): Promise<string> =>
  uploadFile({
    file,
    signBody: {
      item_type: UPLOAD_ITEM_TYPE,
      item_id: Date.now(),
      object_name: file.name,
      object_type: "image",
      object_size: file.size,
    },
  });

export const updateTopBanner = async (
  params: UpdateTopBannerParams,
): Promise<boolean> => {
  const {
    uuid,
    originalBanner,
    title,
    url,
    description,
    is_active,
    expires_at,
    desktopImageFile,
    phoneImageFile,
  } = params;

  const body: Record<string, unknown> = {};
  if (title !== originalBanner.title) body.title = title;
  if (url !== originalBanner.url) body.url = url;
  if (description !== originalBanner.description) body.description = description;
  if (is_active !== originalBanner.is_active) body.is_active = is_active;
  if (expires_at !== originalBanner.expires_at) body.expires_at = expires_at;
  if (desktopImageFile) body.desktop_image = await upload(desktopImageFile);
  if (phoneImageFile) body.phone_image = await upload(phoneImageFile);

  if (!Object.keys(body).length) return true;

  return await api
    .patch<ApiResponse<unknown>>(`${TOP_ENDPOINT}${uuid}/`, body)
    .then(() => true)
    .catch(() => false);
};

export const updateContentBanner = async (
  params: UpdateContentBannerParams,
): Promise<boolean> => {
  const {
    uuid,
    contentType,
    originalBanner,
    title,
    url,
    description,
    is_active,
    content_id,
    desktopImageFile,
    phoneImageFile,
  } = params;

  const body: Record<string, unknown> = {};
  if (title !== originalBanner.title) body.title = title;
  if (url !== originalBanner.url) body.url = url;
  if (description !== originalBanner.description) body.description = description;
  if (is_active !== originalBanner.is_active) body.is_active = is_active;
  if (content_id !== originalBanner.content_id)
    body[CONTENT_FK_FIELD[contentType]] = content_id;
  if (desktopImageFile) body.desktop_image = await upload(desktopImageFile);
  if (phoneImageFile) body.phone_image = await upload(phoneImageFile);

  if (!Object.keys(body).length) return true;

  return await api
    .patch<ApiResponse<unknown>>(`${CONTENT_ENDPOINTS[contentType]}${uuid}/`, body)
    .then(() => true)
    .catch(() => false);
};
